import axios from 'axios';
import { hasFeature } from 'utils/featureFlags';
import {
  GET_FEATURE_PRICE_PER_MONTHS,
  GET_FEATURE_PRICE_PER_MONTHS_FROM_SERVICE,
} from './constants';

export function getFeaturePricePerMonths(data, params) {
  const url = hasFeature('business-type-new-api')
    ? GET_FEATURE_PRICE_PER_MONTHS_FROM_SERVICE
    : GET_FEATURE_PRICE_PER_MONTHS;
  const isWithCredentials = !hasFeature('business-type-new-api');

  if (hasFeature('business-type-new-api')) {
    const feature_names = data.feature_names.join(',');
    return axios.get(url, {
      params: { feature_names },
      withCredentials: isWithCredentials,
    });
  }

  return axios.post(url, data, {
    params,
    withCredentials: isWithCredentials,
  });
}
